import { render, staticRenderFns } from "./Size.vue?vue&type=template&id=20f1e4cb&scoped=true"
import script from "./Size.vue?vue&type=script&lang=js"
export * from "./Size.vue?vue&type=script&lang=js"
import style0 from "./Size.vue?vue&type=style&index=0&id=20f1e4cb&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f1e4cb",
  null
  
)

export default component.exports